import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { RootReducer } from "../../../components/app/reducer"
import { Link } from "react-router-dom"
import { objectFormData } from "../../../utils/formdata"
import api from "../../../data/api"
import { useLocation } from 'react-router-dom';
import { AxiosResponse } from "axios"

const SecuritySavePage : React.FC = () => {
    const searchCriteria = useSelector((state: RootReducer) => state.securityResultReducer.securitiesSearchCriteria);
    const numberOfSecurities = useSelector((state: RootReducer) => state.securityResultReducer.securities?.length) || 0;
    const numberOfGroups = Math.ceil(numberOfSecurities/4000);
    const location = useLocation();
    
    useEffect(() => {
        document.title = "Save As Page"
    }, [])  //The empty array means that the useEffect is gonna be called onMount only

    const generateGroupsCSV = () => {        
        const buttons = [];
        if (searchCriteria) {                                
            let formData = objectFormData(searchCriteria);  
            //formData must look like e.g. { code: "07", name: "---", city: "---" ...}     
            const arrayData : Object[] = [];
            const keys  = Object.keys(formData);  
            keys.forEach( key => {
                arrayData.push({[key] : formData[key]});
            });

            for (let group = 1; group <= numberOfGroups; group++) {                  
                let rowNumberTo = group * 4000;
                let rowNumberFrom = rowNumberTo - 4000 + 1;
                buttons.push (       
                    <div className="floatLeft">                                   
                    <form action="/codelist/luxcsd/v1/SecurityLuxCSD/export/csv" method="post">
                        {/*example of arrayData  [{"code":"07"}, {"name":"---"}, {"city":"---"} ...]*/}
                        {/*generates as many <input> as is objects in the arrData */}
                        {arrayData.map((singleObject : {[index: string]:any} ) => (         
                            <input type="hidden" id={Object.keys(singleObject)[0]} name={Object.keys(singleObject)[0]} value={singleObject[Object.keys(singleObject)[0]]} />     
                        ))}                        
                        <input type="hidden" id="rowNumberFrom" name="rowNumberFrom" value={rowNumberFrom} />     
                        <input type="hidden" id="rowNumberTo" name="rowNumberTo" value={rowNumberTo} />     
                        <button className="link-likebutton" name="Download" formTarget="_blank" type="submit" >Group {group} </button>
                    </form>                  
                    </div>    
                )
            }            
        }   
        return buttons;
    }

    const generateGroupsXML = () => {           
        const buttons = [];
        for (let group = 1; group <= numberOfGroups; group++) {  
            buttons.push (
                <button className="link-likebutton" onClick={() => saveXML(group)}> Group {group} </button> 
            )
        }
        return buttons;    
    }   

    const saveXML = (groupNumber: number) => { 
        if (searchCriteria) {            
            let finalSearchCriteria = objectFormData(searchCriteria);
            let rowNumberTo = groupNumber * 4000;
            let rowNumberFrom = rowNumberTo - 4000 + 1;
            finalSearchCriteria["rowNumberFrom"] = rowNumberFrom;
            finalSearchCriteria["rowNumberTo"] = rowNumberTo;            
            api
            .post("/codelist/luxcsd/v1/SecurityLuxCSD/export/xml",  finalSearchCriteria) 
            .then( (response:AxiosResponse) => {                    
                let xmlData = response.data;        
                let blob = new Blob([xmlData], {type: 'text/xml'});
                let url = URL.createObjectURL(blob);
                let openWindow = window.open(url, 'Download as XML', 'height=600,width=900');
                openWindow?.focus();
                URL.revokeObjectURL(url); //Releases the resources    
            })
        }
    }

    return (
        <div id="savePage">
            <Link to="/securityresults">Back to List</Link>
            <p className="codelist-header"> Securities Details </p>
            {numberOfGroups === 1 ? <p> There is 1 group to download available (4000 securities each). </p>
                                  : <p> There are {numberOfGroups} groups to download available (4000 securities each). </p>
            }            
            <p> Please click below on the group you want to download. </p>                     
            <div>    
                {location.state === 'XML' ? generateGroupsXML() : generateGroupsCSV() }                                 
            </div>                    
        </div>
    )
}

export default SecuritySavePage